import $ from "../../../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {InteractiveButton} from "./InteractiveButton";

// Constructor
export class LanguageSwitcher extends PIXI.Container {

  constructor(game) {
    super();
    this.position.set(140, 1962);

    this.game = game;

    // Get default language and init text
    this.currentLanguage = app.settings.default_language;
    this.game.interfaceLanguageSwitch(this.currentLanguage, true);

    // Synchronize language in all games
    $(document).on('i18nSet', (e) => {
      this.switch(e.lang);
    });

    this.build();

    this.disable();

    return this;
  }

  build() {

    // House
    this.houseContainer = new InteractiveButton(() => {
      app.reset();
    }, true, "audio/MAF_Reactif_Bouton_bas_page.oga");
    const house = new PIXI.Sprite(this.game.assets["house"]);
    house.setSize(53, 60);

    // Languages
    this.languageContainer = new InteractiveButton(() => {
      this.currentLanguage = this.currentLanguage === "en" ? "fr" : "en";
      app.i18n.set(this.currentLanguage);
    }, true, "audio/MAF_Reactif_Bouton_bas_page.oga");

    this.languageContainer.position.set(134, 14);
    this.frenchSprite = new PIXI.Sprite(this.game.assets["language_switcher_fr"]);
    this.englishSprite = new PIXI.Sprite(this.game.assets["language_switcher_en"]);
    this.frenchSprite.setSize(148, 32);
    this.englishSprite.setSize(146, 32);
    if (this.currentLanguage === "en") {
      this.frenchSprite.alpha = 0.0;
    } else {
      this.englishSprite.alpha = 0.0;
    }

    this.houseContainer.addChild(house);
    this.languageContainer.addChild(this.frenchSprite);
    this.languageContainer.addChild(this.englishSprite);
    this.addChild(this.houseContainer);
    this.addChild(this.languageContainer);
  }

  switch(forcedLanguage) {
    // Switch between EN and FR
    this.currentLanguage = forcedLanguage;
    this.game.interfaceLanguageSwitch(this.currentLanguage);

    // Animation
    gsap.to(this.currentLanguage === "en" ? this.frenchSprite : this.englishSprite, {alpha: 0.0, duration: 0.20});
    gsap.to(this.currentLanguage === "en" ? this.englishSprite : this.frenchSprite, {alpha: 1.0, duration: 0.20, delay: 0.20});
  }

  enableHome() {
    this.houseContainer.enable();
    this.houseContainer.alpha = 1;
  }

  disableHome() {
    this.houseContainer.disable();
    this.houseContainer.alpha = 0.5;
  }

  enable() {
    this.houseContainer.enable();
    this.languageContainer.enable();
  }

  disable() {
    this.houseContainer.disable();
    this.languageContainer.disable();
  }
}
